import { Badge } from '@apps/web/components/ui/badge';
import { cn } from '@apps/web/lib/utils';

export type HHAExchangeCaregiverStatus = 'active' | 'inactive' | 'applicant';

export const HHAEXCHANGE_CAREGIVER_STATUS_OPTIONS: ReadonlyArray<HHAExchangeCaregiverStatus> =
    ['active', 'inactive', 'applicant'];

export function formatHHAExchangeCaregiverStatus(
    status: HHAExchangeCaregiverStatus,
): string {
    return status.charAt(0).toUpperCase() + status.slice(1);
}

type HHAExchangeCaregiverStatusBadgeProps = {
    readonly status: HHAExchangeCaregiverStatus;
    readonly className?: string;
};

export function HHAExchangeCaregiverStatusBadge({
    status,
    className,
}: HHAExchangeCaregiverStatusBadgeProps) {
    return (
        <Badge
            variant="outline"
            className={cn(
                status === 'active' &&
                    'border-emerald-600/30 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-950/50 dark:text-emerald-300',
                status === 'inactive' &&
                    'border-border bg-muted text-muted-foreground',
                status === 'applicant' &&
                    'border-blue-600/30 bg-blue-50 text-blue-700 dark:border-blue-500/30 dark:bg-blue-950/50 dark:text-blue-300',
                className,
            )}
        >
            {formatHHAExchangeCaregiverStatus(status)}
        </Badge>
    );
}
